var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8103 2.18973L13 0L12.1897 2.18973L10 3L12.1897 3.81027L13 6L13.8103 3.81027L16 3L13.8103 2.18973ZM8.04391 7.95611L6.33333 3.33335L4.62276 7.95611L0 9.66668L4.62276 11.3773L6.33333 16L8.04391 11.3773L12.6667 9.66668L8.04391 7.95611Z",
    fill: "url(#paint0_linear_9550_21964)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9550_21964",
    x1: -4.4192e-9,
    y1: 2.66667,
    x2: 16.0004,
    y2: 2.65155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E0A4"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.ada2098025f6107ce28cbf63e26a2dff.svg";
export { ForwardRef as ReactComponent };